module.exports = __webpack_public_path__ + "img/horizontal_7_4_6005.87846b62.png";